<template>
  <v-container  ref="barWrapper" fluid fill-height  ma-0 pa-0 >
    <loading-circle
      :show="loader"
    />
    <v-layout column fill-height>
      <v-toolbar color="secondary" dense>
        <v-toolbar-title>
          <span class="body-1 uppercase white--text">{{ $t('Task') }} {{ data.id }}</span>
        </v-toolbar-title>
        <v-layout fill-height justify-end>
          <v-tooltip dark color="secondary" left>
            <v-btn :data-testid="$options.name + 'v-btn' + 'emit-close'" icon flat slot="activator" @click="$emit('close')">
              <v-icon color="white">close</v-icon>
            </v-btn>
            <span>{{ $t('close') }}</span>
          </v-tooltip>
        </v-layout>
      </v-toolbar>

      <scroll-table
        :data="getTable"
        :options="options"
        :sortable="false"
        :translate="true"
        :subscribed="true"
        :hideValues="['undefined']"
        @select=""
      />
    </v-layout>
  </v-container>
</template>

<script>

import scrollTable from '@/nms/components/partials/scrolltable.vue'
import loadingCircle from '@/nms/components/partials/loader.vue'
import tamd from '@/nms/components/modal/components/tasksArchModalDescriptor.js'
import trmd from '@/nms/components/modal/components/tasksRealModalDescriptor.js'

export default {

  name: 'TASKS_MODAL',

  components: {
    scrollTable,
    loadingCircle,
  },

  props: {
    data: {
      type: Object,
      default: () => ({})
    },

    mode: {
      type: String,
      default: () => ('')
    },
  },

  data: () => ({
    loader: false,
    options: {
      columns: {
        text: {
          width: '40%'
        },
        timestamp: {
          width: '40%'
        },
        timestamp: {
          width: '40%'
        },
        actions: {
          width: '40%'
        },
        endpoint: {
          width: '40%'
        },
        check: {
          width: '20%'
        },
      },
    },
    filter: null,
    search: '',
    table: {
      columns: [
        {
          title: 'message',
          value: 'message',
          type: 'text',
          width: '40%'
        },
        {
          title: 'status',
          value: 'status',
          type: 'text',
          width: '30%'
        },
        {
          title: 'description',
          value: 'processing',
          type: 'text',
          width: '30%'
        },
      ],
      rows: []
    },
  }),

  computed: {
    getTable: function () {
      let t = this.$merge({}, this.table)
      return t
    },
  },

  watch: {},

  created () {
    this.setup()
  },

  mounted () {},

  updated () {},

  beforeDestroy () {},

  methods: {
    setup: async function () {
      console.log(this.$options.name, 'statusSubscribe', 'data', this.data)
      console.log(this.$options.name, 'statusSubscribe', 'mode', this.mode)
      this.reset()
      this.statusUnsubscribe('TASKS_MODAL')
      this.prepareTable()
    },

    setLoader: function(name, status) {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    prepareTable: async function () {
      try {
        if(this.mode && this.mode == 'realtime') {
          this.table.columns = trmd.columns
          if(!this.data.progress || !this.data.progress.length) return
          this.loader = true
          this.data.progress.forEach(status => {
              this.table.rows.push(status)    
          })
          console.log(this.$options.name, 'prepareTable', 'this.table', this.table)
          this.loader = false
          this.statusSubscribe(this.table.rows, 'TASKS_MODAL')
        }
        if(this.mode && this.mode == 'archive') {
          this.table.columns = tamd.columns
          console.log(this.$options.name, 'ARCHIVE ID', this.data)
          console.log(this.$options.name, 'ARCHIVE type', typeof this.data.data)
          if (this.data.data && typeof this.data.data === 'string'){
            let d = JSON.parse(this.data.data)
            if(d.progress) {
              this.table.rows = d.progress
            }
          }
          else if (this.data.data && typeof this.data.data === 'object'){
            this.table.rows.push(this.data.data)
          }
        }
      }
      catch(err) {
        console.error('CATCH', this.$options.name, 'prepareTable', err)
        this.loader = false
      }

    },

    statusSubscribe: async function (arr, group) {
      this.$store.dispatch('measuresSubscribeInit', {
        name: 'addStatus',
        group: group,
        listener: 'status'
      })
      if(arr.length) {
        arr.forEach((item, i) => {
          if(item.$id) {
            this.$store.dispatch('addStatusKey',item)
          }
        });
        await this.$bridge.subscribe(arr.map(obj => obj.$id))
      }
    },

    subscribeHandler: function (e) {
      if (e.$id) {
        this.$store.dispatch('addStatus', e)
      }
    },

    statusUnsubscribe: function (group) {
      this.$store.dispatch('measuresSubscribeClose', {
        handler: this.subscribeHandler,
        group: group,
        listener: 'status'
      })
    },

    reset: function () {
      this.table.columns = []
      this.table.rows = []
    }

  }

}
</script>

<style scoped lang="less">

</style>
